import { Component } from '@angular/core';

@Component({
  selector: 'app-email-policy-break',
  templateUrl: './email-policy-break.component.html',
  styleUrls: ['./email-policy-break.component.scss']
})
export class EmailPolicyBreakComponent {

}
